// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607080534/js/" + chunkId + "." + {"44":"2b283153","225":"6460a2c5","481":"05df0cfb","486":"13df62f4","770":"57f59491"}[chunkId] + ".0.5927646433300573.chunk.js";
};